import * as _ from 'underscore';

export const getBalanceByName = (balanceType, balances, formatter, options) => {
    const balance = _.findWhere(balances, { balanceType });

    if (!balance) {
        return '0';
    }

    return formatter.formatCurrency(balance.balance?.amount, balance.balance?.currencyCode, options);
};
